import { MaintenanceRequest } from '../../../models/maintenance.model';

/**
 * Pure helpers shared by the Maintenance page and the business profile's Access panel, kept out of the components so
 * the date handling is pinned by tests without a TestBed.
 */

/** A `datetime-local` value for an instant, in the browser's zone, or '' for none. */
export function toLocalInput(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(/(Z|[+-]\d{2}:?\d{2})$/i.test(iso) ? iso : `${iso}Z`);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** The request body for the form's values: a blank message is left out, a local time becomes UTC. */
export function toRequest(message: string, expectedEndLocal: string): MaintenanceRequest {
  const trimmed = (message || '').trim();
  const local = (expectedEndLocal || '').trim();
  const expected = local ? new Date(local) : null;
  return {
    message: trimmed || null,
    expectedEndUtc: expected && !Number.isNaN(expected.getTime()) ? expected.toISOString() : null
  };
}

/** "An expected end that has already passed" is the one mistake worth stopping before the confirm. */
export function expectedEndProblem(expectedEndLocal: string, now: Date = new Date()): string {
  const local = (expectedEndLocal || '').trim();
  if (!local) return '';
  const expected = new Date(local);
  if (Number.isNaN(expected.getTime())) return 'That is not a date and time.';
  if (expected.getTime() <= now.getTime()) return 'The expected end has already passed. Leave it blank if you do not know yet.';
  return '';
}
